import { createContext, useContext, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { thisMonthObjectNepali } from '@/common/custom-date-selector copy/helpers';
import useAppData from '@/hooks/useAppData';
// import { userData } from '@/common/custom-date-selector-list/helpers';

// import barcodeCSS from '@/pages/admin/printer/barcode/defaultBarcodeCSS.css?inline';

const TransactionContext = createContext();

/**
 * Custom hook to use the TransactionContext.
 *
 * @returns {Object} The context value, which includes transaction data and related functions.
 */
export const useTransactionContext = () => useContext(TransactionContext);

/**
 * Provider component that wraps its children in TransactionContext.
 *
 * @param {Object} props - The props for the provider.
 * @param {React.ReactNode} props.children - The child components that will have access to the TransactionContext.
 *
 * @returns {React.ReactElement} The provider component wrapping its children in TransactionContext.
 */
export const TransactionContextProvider = ({ children }) => {
  const { app } = useAppData();
  const [totalPcsDiamond, setTotalPcsDiamond] = useState(0);
  const [totalPcsStone, setTotalPcsStone] = useState(0);
  const [totalDiamondWeight, setTotalDiamondWeight] = useState(0);
  const [totalStoneWeight, setTotalStoneWeight] = useState(0);
  const [totalPrate, setTotalPrate] = useState(0);
  const [totalDiamondAmount, setTotalDiamondAmount] = useState(0);
  const [totalGramLalValue, setTotalGramLalValue] = useState(0);
  const [issueId, setIssueId] = useState(null);

  const [isNewEntry, setIsNewEntry] = useState(false);

  const [itemData, setItemData] = useState({ itemId: '', itemName: '' });
  const [adjustmentModal, setOpenAdjustmentModal] = useState(false);

  const [paymentVoucherTotal, setPaymentVoucherTotal] = useState(0);

  const [billNumber, setBillNumber] = useState('');

  const [checkbox, setCheckbox] = useState(false);

  const [receiveFromPartyId, setReceiveFromPartyId] = useState(null);

  const [ledgerRowSelection, setLedgerRowSelection] = useState([]);

  const [isReceiveFromParty, setIsReceiveFromParty] = useState(false);

  const [taxVat, setTaxVat] = useState({
    isTaxApplicable: app?.isTaxApplicable ?? false,
    isVatApplicable: app?.isVatApplicable ?? false,
  });
  const [itemTypeName, setItemTypeName] = useState('');

  const [groupIds, setGroupIds] = useState([]);
  const [categoryIds, setCategoryIds] = useState([]);

  const [billFormatList, setBillFormatList] = useState([]);
  const [billFormatId, setBillFormatId] = useState();

  const [fileList, setFileList] = useState([]);

  const [fileListNew, setFileListNew] = useState([]);

  const [uploadFileList, setUploadFileList] = useState([]);

  const [receiptTotalAmt, setReceiptTotalAmt] = useState(0);
  const [modalPurchase, setModalPurchase] = useState(false);

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [expandedData, setExpandedData] = useState({});

  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      receiveTo: '',
      amount: 0,
      remarks: '',
    },
  ]);

  const [receiptVoucherHeader, setReceiptVoucherHeader] = useState({
    voucherType: 'receipt',
    voucherNo: '',
    voucherDate: '',
    voucherId: null,
    remarks: '',
  });

  const [paymentdataSource, setPaymentDataSource] = useState([
    {
      key: 0,
      payFrom: null,
      amount: 0,
      remarks: null,
    },
  ]);

  const [paymentVoucherHeader, setPaymentVoucherHeader] = useState({
    voucherType: 'payment',
    voucherNo: '',
    voucherDate: '',
    voucherId: null,
    remarks: '',
  });

  const [modalVisible, setModalVisible] = useState({
    receipt: false,
    payment: false,
    contra: false,
    journal: false,
    metalToCashPayment: false,
    metalToCashReceipt: false,
  });

  const [showDetailReport, setShowDetailReport] = useState(false);

  const [reportStatus, setReportStatus] = useState('vr');

  const [searchByUnit, setSearchByUnit] = useState('weightInGram');

  const [cashPaidTotal, setCashPaidTotal] = useState(null);

  const [isPurchaseEditFromSales, setIsPurchaseEditFromSales] = useState(false);
  const [isPurchaseEditFromSalesOrder, setIsPurchaseEditFromSalesOrder] =
    useState(false);
  const [receiveCodeWindowTitle, setReceiveCodeWindowTitle] =
    useState('Create Receive');

  const [hiddenValueChange, setHiddenValueChange] = useState(null);

  const [periodValue, setPeriodValue] = useState(
    app?.isActive ? 'Last 7 Days' : 'All',
  );

  const [quickPurchaseTableData, setQuickPurchaseTableData] = useState([]);

  const [salesKycStatus, setSalesKycStatus] = useState(null);
  const [diamondCodeWindowId, setDiamondCodeWindowId] = useState(null);
  const [diamondCodeWindowOptions, setDiamondCodeWindowOptions] = useState({});
  const [openDiamondStoneOnly, setOpenDiamondStoneOnly] = useState(false);

  const [salesStartDate, setSalesStartDate] = useState({
    // '/sales/list/': dayjs().subtract(6, 'days').format('YYYY-MM-DD'),
    '/sales/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/purchase/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/sales/order/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/sales/return/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/purchase/return/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/issues/karigar/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/issues/refine/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/issues/party/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/receives/karigar/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/receives/refine/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/receives/party/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/metal-to/cash/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/receipt/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/journal/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/contra/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/accounting/cash-to-metals/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/accounting/metal-transfer/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/payment/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/opening/stock/code/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/dashboard/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/transaction/quotation/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
  });

  const [salesEndDate, setSalesEndDate] = useState({
    '/sales/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/purchase/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/sales/order/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/sales/return/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/purchase/return/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/issues/karigar/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/issues/refine/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/issues/party/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/receives/karigar/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/receives/refine/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/receives/party/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/metal-to/cash/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/receipt/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/journal/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/contra/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/payment/voucher/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/accounting/cash-to-metals/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/accounting/metal-transfer/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/transaction/stock-adjustment/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/opening/stock/code/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialEndYear,
    '/dashboard/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
    '/transaction/quotation/list/': app?.isActive
      ? dayjs().format('YYYY-MM-DD')
      : app?.financialStartYear,
  });

  const [calculatorOpen, setCalculatorOpen] = useState(false);

  const [targetId, setTargetId] = useState(null);

  const [result, setResult] = useState('');

  const [periodValueList, setPeriodValueList] = useState({
    '/sales/list/': app?.isActive ? 'Today' : 'All',
    '/purchase/list/': app?.isActive ? 'Today' : 'All',
    '/sales/order/list/': app?.isActive ? 'Today' : 'All',
    '/sales/return/list/': app?.isActive ? 'Today' : 'All',
    '/purchase/return/list/': app?.isActive ? 'Today' : 'All',
    '/issues/karigar/list/': app?.isActive ? 'Today' : 'All',
    '/issues/refine/list/': app?.isActive ? 'Today' : 'All',
    '/issues/party/list/': app?.isActive ? 'Today' : 'All',
    '/receives/karigar/list/': app?.isActive ? 'Today' : 'All',
    '/receives/refine/list/': app?.isActive ? 'Today' : 'All',
    '/receives/party/list/': app?.isActive ? 'Today' : 'All',
    '/metal-to/cash/list/': app?.isActive ? 'Today' : 'All',
    '/receipt/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/journal/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/contra/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/payment/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/accounting/cash-to-metals/list/': app?.isActive ? 'Today' : 'All',
    '/accounting/metal-transfer/list/': app?.isActive ? 'Today' : 'All',
    '/opening/stock/list/': app?.isActive ? 'Today' : 'All',
    '/transaction/stock-adjustment/list/': app?.isActive ? 'Today' : 'All',
    '/sales/return/list': app?.isActive ? 'Today' : 'All',
    '/purchase/return/list': app?.isActive ? 'Today' : 'All',
    '/loan/party-loans/list/': app?.isActive ? 'Today' : 'All',
    '/loan/deals/list/': app?.isActive ? 'Today' : 'All',
    '/loan/bank-issues/list/': app?.isActive ? 'Today' : 'All',
    '/loan/interest-receives/list/': app?.isActive ? 'Today' : 'All',
    '/loan/bank-receives/list/': app?.isActive ? 'Today' : 'All',
    '/loan/deals/close/list/': app?.isActive ? 'Today' : 'All',
    '/dashboard/': app?.isActive ? 'Today' : 'All',
    '/transaction/quotation/list/': app?.isActive ? 'Today' : 'All',
  });

  const [selectedPeriodList, setSelectedPeriodList] = useState({
    '/sales/list/': app?.isActive ? 'Today' : 'All',
    '/purchase/list/': app?.isActive ? 'Today' : 'All',
    '/sales/order/list/': app?.isActive ? 'Today' : 'All',
    '/sales/return/list/': app?.isActive ? 'Today' : 'All',
    '/purchase/return/list/': app?.isActive ? 'Today' : 'All',
    '/issues/karigar/list/': app?.isActive ? 'Today' : 'All',
    '/issues/refine/list/': app?.isActive ? 'Today' : 'All',
    '/issues/party/list/': app?.isActive ? 'Today' : 'All',
    '/receives/karigar/list/': app?.isActive ? 'Today' : 'All',
    '/receives/refine/list/': app?.isActive ? 'Today' : 'All',
    '/receives/party/list/': app?.isActive ? 'Today' : 'All',
    '/metal-to/cash/list/': app?.isActive ? 'Today' : 'All',
    '/receipt/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/journal/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/contra/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/payment/voucher/list/': app?.isActive ? 'Today' : 'All',
    '/accounting/cash-to-metals/list/': app?.isActive ? 'Today' : 'All',
    '/accounting/metal-transfer/list/': app?.isActive ? 'Today' : 'All',
    '/opening/stock/list/': app?.isActive ? 'Today' : 'All',
    '/transaction/stock-adjustment/list/': app?.isActive ? 'Today' : 'All',
    '/sales/return/list': app?.isActive ? 'Today' : 'All',
    '/purchase/return/list': app?.isActive ? 'Today' : 'All',
    '/loan/party-loans/list/': app?.isActive ? 'Today' : 'All',
    '/loan/deals/list/': app?.isActive ? 'Today' : 'All',
    '/loan/bank-issues/list/': app?.isActive ? 'Today' : 'All',
    '/loan/interest-receives/list/': app?.isActive ? 'Today' : 'All',
    '/loan/bank-receives/list/': app?.isActive ? 'Today' : 'All',
    '/loan/deals/close/list/': app?.isActive ? 'Today' : 'All',
    '/dashboard/': app?.isActive ? 'Today' : 'All',
    '/transaction/quotation/list/': app?.isActive ? 'Today' : 'All',
  });

  const [dateType, setDateType] = useState(
    app?.dateType?.toLowerCase() === 'bs' ? 'bs' : 'ad',
  );

  const [dateTypeList, setDateTypeList] = useState(
    app?.dateType?.toLowerCase() === 'bs' ? 'bs' : 'ad',
  );

  const [persistedDateType, setPersistedDateType] = useState(
    app?.dateType?.toLowerCase() === 'bs' ? 'bs' : 'ad',
  );

  const [startDate, setStartDate] = useState(
    app?.isActive
      ? dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      : app?.financialStartYear,
  );

  const [endDate, setEndDate] = useState(
    app?.isActive ? dayjs().format('YYYY-MM-DD') : app?.financialEndYear,
  );

  const [startDateLD, setStartDateLD] = useState(
    // dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
    app?.isActive
      ? thisMonthObjectNepali?.value?.from?.date
      : app?.financialStartYear,
  );

  const [endDateLD, setEndDateLD] = useState(
    app?.isActive
      ? thisMonthObjectNepali?.value?.to?.date
      : app?.financialEndYear,
  );

  const [ledgerPath, setLedgerPath] = useState(null);

  const [totalStoneAmount, setTotalStoneAmount] = useState(0);
  const [previousPath, setPreviousPath] = useState('');
  const [globalDividerTitle, setGlobalDividerTitle] = useState('');
  const [voucherModalData, setVoucherModalData] = useState([]);
  const [editApiBlock, setEditApiBlock] = useState(false);
  const [showSalesDescription, setShowSalesDescription] = useState(true);
  const [reportUrl, setReportUrl] = useState('');
  const [issuePage, setIssuePage] = useState('');

  const [ledgerDetails, setLedgerDetails] = useState(null);
  const [stockDetails, setStockDetails] = useState(null);

  const [isCancel, setIsCancel] = useState(null);
  const [record, setRecord] = useState({
    value: '',
    index: '',
    itemName: '',
  });

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [open, setOpen] = useState(false);

  //store ids of the order Data
  const [selectedIds, setSelectedIds] = useState([]);

  //store the whole selected rows of the order data
  const [selectedRows, setSelectedRows] = useState([]);

  //store the all coming json of the order data
  const [salesOrderDetails, setSalesOrderDetails] = useState([]);

  //Puchase json and final net amount to be used for sales page
  const [purchaseNetAmount, setPurchaseNetAmount] = useState(0);

  const [receiveFromPartyNetAmount, setReceiveFromPartyNetAmount] = useState(0);
  const [receiveFromPartyPureWeight, setReceiveFromPartyWeight] = useState(0);
  const [purchaseFinalJson, setPurchaseFinalJson] = useState({});
  const [prefixResponse, setPrefixResponse] = useState({});
  const [from, setFrom] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null);

  const [cancelledItemCode, setCancelledItemCode] = useState(null);

  const [salesSelectReferenceId, setSalesSelectReferenceId] = useState([]);
  const [salesToPurchase, setSalesToPurchase] = useState(false);

  const [selectedReferenceId, setSelectedReferenceId] = useState(null);

  const [formData, setFormData] = useState({
    purity: 0,
    crt: 0,
    percent: 0,
    makingCharge: 0,
    makingChargeType: '',
    makingAmount: 0,
    wastageType: '',
    wastageWeight: 0,
    grossWeight: 0,
    rate: 0,
    wastageCharge: 0,
    setPcs: 0,
    extraAmount: 0,
    diamondWeightGram: 0,
    stoneWeightGram: 0,
    diamondAmount: 0,
    stoneAmount: '',
    netWeight: '',
    fixedAmount: 'no',
    netAmount: '',
    metalWeight: '',
    netWithWastage: '',
    pureWeight: '',
    diamondPcs: '',
    diamondWeightCrt: '',
    stoneWeightCrt: '',
    metalAmount: '',
    itemId: '',
  });

  const [selectedData, setSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    cashPaid: 0,
    discountAmount: 0,
  });

  const [selectedDataSo, setSelectedDataSo] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    cashPaid: 0,
  });
  const [stockSelectedData, setStockSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    cashPaid: 0,
  });
  const [receiveSelectedData, setReceiveSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    wtInTola: '',
    pureWeight: '',
  });

  const [salesSelectedData, setSalesSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    remarks: '',
    advanceAmount: 0,
  });

  const [salesOrderSelectedData, setSalesOrderSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    entryDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    wtInTola: '',
    pureWeight: '',
  });

  const [issueSelectedData, setIssueSelectedData] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    issueDate: null,
    item: '',
    code: '',
    ledgerName: '',
    itemName: '',
    wtInTola: '',
    pureWeight: '',
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [salesTableData, setSalesTableData] = useState([
    {
      id: Date.now().toString(),
      // item: '',
      // code: '',
      // gwt: 0,
      // dsWt: 0,
      // nwt: 0,
      // rate: 0,
      // netWithWastage: 0,
      // amount: 0,
      // netAmount: 0,
      // itemName: '',
    },
  ]);

  const [tableData, setTableData] = useState([
    {
      key: '1',
      typeId: '',
      rateOn: '',
      pcs: 0,
      unit: '',
      weight: '',
      purchaseRate: 0,
      salesRate: 0,
      hc: '',
      color: '',
      clarity: '',
      cut: '',
      amount: 0,
      remark: '',
      isName: '',
      itemTypeId: '',
      itemTypeName: '',
      disabledUnit: false,
    },
  ]);

  const [purchaseTableData, setpurchaseTableData] = useState([
    {
      id: Date.now().toString(),
      item: '',
      code: '',
      gwt: '',
      dsWt: '',
      nwt: '',
      rate: '',
      netWithWastage: '',
      amount: '',
      netAmount: '',
      itemName: '',
      wtInTola: '',
      pureWeight: '',
      taxPercent: 2,
      vatPercent: 0,
    },
  ]);

  const [salesOrderTableData, setSalesOrderTableData] = useState([
    {
      id: Date.now().toString(),
      item: '',
      code: '',
      gwt: '',
      dsWt: '',
      nwt: '',
      rate: '',
      netWithWastage: '',
      amount: '',
      netAmount: '',
      itemName: '',
      wtInTola: '',
      pureWeight: '',
    },
  ]);

  const [stockTableData, setStockTabledata] = useState([
    {
      id: Date.now().toString(),
      item: '',
      code: '',
      gwt: 0,
      dsWt: 0,
      nwt: 0,
      rate: 0,
      netWithWastage: 0,
      amount: 0,
      netAmount: 0,
      itemName: '',
    },
  ]);

  const [issueTableData, setIssueTabledata] = useState([
    {
      id: Date.now().toString(),
      item: '',
      code: '',
      gwt: '',
      dsWt: '',
      nwt: '',
      rate: '',
      netWithWastage: '',
      amount: '',
      netAmount: '',
      itemName: '',
    },
  ]);
  const [barcodePrinterStatus, setBarcodePrinterStatus] = useState(
    localStorage.getItem('barcodePrinterStatus') || true,
  );

  const clearAllStates = () => {
    setIssueTabledata([{}]);
    setStockTabledata([{}]);
    setpurchaseTableData([{}]);
    setTableData([{}]);
    setSalesOrderTableData[{}];
    setSalesTableData([{}]);
    setIssueSelectedData([{}]);
    setSalesSelectedData([{}]);
    setSalesOrderSelectedData([{}]);
    setStockSelectedData([{}]);
    setReceiveSelectedData([{}]);
    setSelectedData([{}]);
    setBarcodePrinterStatus(false);
  };

  /**
   * Updates the sales table data.
   *
   * @param {Object} rowNewData - The new data for the row.
   */
  const onSalesTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setSalesTableData((prev) => [...prev, { ...rowNewData }]);
      return;
    }

    const rowIndex = salesTableData.findIndex(
      (rowData) => (rowData?.id || rowData.codeWindowId) === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setSalesTableData((prev) => [...prev, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...salesTableData];
      newData.splice(rowIndex, 1);
      setSalesTableData(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setSalesTableData({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...salesTableData];
    newData[rowIndex] = { ...rowNewData };
    setSalesTableData(newData);
  };

  /**
   * Updates the issue table data.
   *
   * @param {Object} rowNewData - The new data for the row.
   */
  const onIssueTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setIssueTabledata([...issueTableData, { ...rowNewData }]);
      return;
    }

    const rowIndex = issueTableData.findIndex(
      (rowData) => rowData?.id === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setIssueTabledata([...issueTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...issueTableData];
      newData.splice(rowIndex, 1);
      setIssueTabledata(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setIssueTabledata({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...issueTableData];
    newData[rowIndex] = { ...rowNewData };
    setIssueTabledata(newData);
  };

  /**
   * Updates the purchase table data.
   *
   * @param {Object} rowNewData - The new data for the row.
   */
  const onPurchaseTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setpurchaseTableData((prev) => [...prev, { ...rowNewData }]);
      return;
    }

    const rowIndex = purchaseTableData?.findIndex(
      (rowData) => (rowData?.id || rowData.codeWindowId) === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setpurchaseTableData([...purchaseTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...purchaseTableData];
      newData.splice(rowIndex, 1);
      setpurchaseTableData(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setpurchaseTableData({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...purchaseTableData];
    newData[rowIndex] = { ...rowNewData };
    setpurchaseTableData(newData);
  };

  const onSalesOrderTableDataChange = (rowNewData) => {
    // Check if it's a new row

    // salesOrderTableData,
    // setSalesOrderTableData,

    if (rowNewData?.new) {
      setSalesOrderTableData([...salesOrderTableData, { ...rowNewData }]);
      return;
    }

    const rowIndex = salesOrderTableData?.findIndex(
      (rowData) => (rowData?.id || rowData.codeWindowId) === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setSalesOrderTableData([...salesOrderTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...salesOrderTableData];
      newData.splice(rowIndex, 1);
      setSalesOrderTableData(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setSalesOrderTableData({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...salesOrderTableData];
    newData[rowIndex] = { ...rowNewData };
    setSalesOrderTableData(newData);
  };

  const onStockTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setStockTabledata([...stockTableData, { ...rowNewData }]);
      return;
    }

    const rowIndex = stockTableData.findIndex(
      (rowData) => (rowData?.id || rowData.codeWindowId) === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setStockTabledata([...stockTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...stockTableData];
      newData.splice(rowIndex, 1);
      setStockTabledata(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setStockTabledata({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...stockTableData];
    newData[rowIndex] = { ...rowNewData };
    setStockTabledata(newData);
  };
  const [receiveTableData, setReceiveTabledata] = useState([
    {
      id: Date.now().toString(),
      item: '',
      code: '',
      gwt: '',
      dsWt: '',
      nwt: '',
      rate: '',
      netWithWastage: '',
      amount: '',
      netAmount: '',
      itemName: '',
    },
  ]);

  const onReceiveTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setReceiveTabledata([...receiveTableData, { ...rowNewData }]);
      return;
    }

    const rowIndex = receiveTableData.findIndex(
      (rowData) => (rowData?.id || rowData.codeWindowId) === rowNewData?.id,
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setReceiveTabledata([...receiveTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...receiveTableData];
      newData.splice(rowIndex, 1);
      setReceiveTabledata(newData);
      return;
    }

    if (rowNewData?.clearContent) {
      setReceiveTabledata({
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
      });
    }

    // Update the existing row
    const newData = [...receiveTableData];
    newData[rowIndex] = { ...rowNewData };
    setReceiveTabledata(newData);
  };

  const [refineGrossWeight, setRefineGrossWeight] = useState(0);

  const [billTemplate, setBillTemplate] = useState(false);
  const [billTemplateCustom, setBillTemplateCustom] = useState(false);
  const [billTemplateDataCustom, setBillTemplateDataCustom] = useState(null);
  const [billPrintUrls, setBillPrintUrls] = useState({
    DATA_URL: '',
    INCREMENT_URL: '',
    BILL_SETUP_URL: '',
  });
  return (
    <TransactionContext.Provider
      value={{
        globalDividerTitle,
        setGlobalDividerTitle,
        voucherModalData,
        setVoucherModalData,
        salesOrderDetails,
        setSalesOrderDetails,
        selectedRows,
        setSelectedRows,
        selectedIds,
        calculatorOpen,
        setCalculatorOpen,
        targetId,
        setTargetId,
        result,
        setResult,
        setSelectedIds,
        previousPath,
        setPreviousPath,
        issueSelectedData,
        setIssueSelectedData,
        issueTableData,
        setIssueTabledata,
        onIssueTableDataChange,
        purchaseFinalJson,
        setPurchaseFinalJson,
        purchaseNetAmount,
        prefixResponse,
        setPrefixResponse,
        setPurchaseNetAmount,
        receiveFromPartyNetAmount,
        setReceiveFromPartyNetAmount,
        receiveFromPartyPureWeight,
        setReceiveFromPartyWeight,
        formData,
        setFormData,
        salesSelectedData,
        setSalesSelectedData,
        cancelledItemCode,
        // editedRowRef,
        setCancelledItemCode,
        salesOrderSelectedData,
        setSalesOrderSelectedData,
        receiveSelectedData,
        setReceiveSelectedData,
        receiveTableData,
        setReceiveTabledata,
        onReceiveTableDataChange,
        stockTableData,
        setStockTabledata,
        onStockTableDataChange,
        onPurchaseTableDataChange,
        onSalesOrderTableDataChange,
        purchaseTableData,
        setpurchaseTableData,
        selectedData,
        salesOrderTableData,
        setSalesOrderTableData,
        setSelectedData,
        stockSelectedData,
        selectedDataSo,
        setSelectedDataSo,
        setStockSelectedData,
        salesTableData,
        setSalesTableData,
        cashPaidTotal,
        setCashPaidTotal,
        hiddenValueChange,
        expandedKeys,
        setExpandedKeys,
        expandedData,
        setExpandedData,
        setHiddenValueChange,
        onSalesTableDataChange,
        tableData,
        setTableData,
        setTotalDiamondAmount,
        setTotalDiamondWeight,
        setTotalPcsDiamond,
        setTotalPcsStone,
        setTotalStoneWeight,
        setTotalPrate,
        setTotalStoneAmount,
        totalPcsDiamond,
        totalPcsStone,
        ledgerRowSelection,
        setLedgerRowSelection,
        isReceiveFromParty,
        setIsReceiveFromParty,
        taxVat,
        setTaxVat,
        receiptTotalAmt,
        setReceiptTotalAmt,
        fileList,
        setFileList,
        fileListNew,
        setFileListNew,
        uploadFileList,
        setUploadFileList,
        modalPurchase,
        setModalPurchase,
        showDetailReport,
        setShowDetailReport,
        reportStatus,
        setReportStatus,
        searchByUnit,
        setSearchByUnit,
        modalVisible,
        setModalVisible,
        startDate,
        setStartDate,
        periodValue,
        setPeriodValue,
        periodValueList,
        setPeriodValueList,
        selectedPeriodList,
        setSelectedPeriodList,
        salesStartDate,
        setSalesStartDate,
        salesKycStatus,
        setSalesKycStatus,
        diamondCodeWindowId,
        setDiamondCodeWindowId,
        diamondCodeWindowOptions,
        setDiamondCodeWindowOptions,
        openDiamondStoneOnly,
        setOpenDiamondStoneOnly,
        quickPurchaseTableData,
        setQuickPurchaseTableData,
        salesEndDate,
        setSalesEndDate,
        adjustmentModal,
        setOpenAdjustmentModal,
        dateType,
        setDateType,
        dateTypeList,
        setDateTypeList,
        persistedDateType,
        setPersistedDateType,
        endDate,
        setEndDate,
        startDateLD,
        setStartDateLD,
        endDateLD,
        setEndDateLD,
        dataSource,
        setDataSource,
        paymentVoucherTotal,
        setPaymentVoucherTotal,
        billNumber,
        setBillNumber,
        checkbox,
        setCheckbox,
        receiveFromPartyId,
        setReceiveFromPartyId,
        ledgerPath,
        setLedgerPath,
        totalDiamondWeight,
        totalStoneWeight,
        totalPrate,
        totalDiamondAmount,
        totalStoneAmount,
        editApiBlock,
        setEditApiBlock,
        showSalesDescription,
        setShowSalesDescription,
        reportUrl,
        setReportUrl,
        issuePage,
        setIssuePage,
        selectedRowKeys,
        setSelectedRowKeys,
        isModalVisible,
        setIsModalVisible,
        isCancel,
        setIsCancel,
        open,
        setOpen,
        record,
        setRecord,
        ledgerDetails,
        setLedgerDetails,
        stockDetails,
        setStockDetails,
        refineGrossWeight,
        setRefineGrossWeight,
        clearAllStates,
        from,
        setFrom,
        totalGramLalValue,
        setTotalGramLalValue,
        selectedItems,
        setSelectedItems,
        selectedRowKey,
        setSelectedRowKey,
        salesToPurchase,
        setSalesToPurchase,
        barcodePrinterStatus,
        setBarcodePrinterStatus,
        salesSelectReferenceId,
        setSalesSelectReferenceId,
        itemData,
        setItemData,
        paymentdataSource,
        setPaymentDataSource,
        setPaymentVoucherHeader,
        paymentVoucherHeader,
        receiptVoucherHeader,
        setReceiptVoucherHeader,
        issueId,
        setIssueId,
        categoryIds,
        groupIds,
        setCategoryIds,
        setGroupIds,
        billFormatList,
        setBillFormatList,
        billFormatId,
        setBillFormatId,
        itemTypeName,
        setItemTypeName,
        isNewEntry,
        setIsNewEntry,
        billTemplate,
        setBillTemplate,
        billTemplateCustom,
        setBillTemplateCustom,
        billPrintUrls,
        setBillPrintUrls,
        billTemplateDataCustom,
        setBillTemplateDataCustom,
        isPurchaseEditFromSales,
        setIsPurchaseEditFromSales,
        isPurchaseEditFromSalesOrder,
        setIsPurchaseEditFromSalesOrder,
        receiveCodeWindowTitle,
        setReceiveCodeWindowTitle,
        selectedReferenceId,
        setSelectedReferenceId,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};
